export const pathAssetsBase: string = import.meta.env.VITE_APP_PATH_ASSETS ||
    'https://appspowerplaymanager.vshcdn.net/images/summer-sports/minigame/'
export const pathAssets = `${pathAssetsBase}keirin`
export const pathAssetsGlobal = `${pathAssetsBase}global`
export const pathAssetsCoreUi = 'https://appspowerplaymanager.vshcdn.net/images/minigame/core-ui'
